import React from "react";

import { formatNumber } from "@formant/core/common/formatNumber";
import { IEventCounts } from "@formant/core/model/IEventCounts";
import { Badge } from "@formant/ui-kit";
import { cn } from "@formant/ui-kit/src/lib/utils";

export type VariantType = "info" | "warning" | "error" | "critical";

export const getVariant = (counts?: IEventCounts): VariantType => {
    const { info, warning, error, critical } = {
        info: 0,
        warning: 0,
        error: 0,
        critical: 0,
        ...counts,
    };

    const variant =
        critical > 0
            ? "critical"
            : error > 0
              ? "error"
              : warning > 0
                ? "warning"
                : info > 0
                  ? "info"
                  : "info";

    return variant;
};

export const compareVariantAndReturnMostSevere = (
    variant1: VariantType,
    variant2: VariantType,
) => {
    const priority = {
        info: 0,
        warning: 1,
        error: 2,
        critical: 3,
    };

    return priority[variant1] < priority[variant2] ? variant2 : variant1;
};

export interface IProps {
    onClick: () => void;
    counts?: IEventCounts;
}
export const FleetEventBadgePassive = (props: IProps) => {
    const { counts, onClick } = props;
    const {
        "triggered-event": triggeredEvents,
        "intervention-request": interventions,
        custom,
        stateful,
    } = {
        "triggered-event": 0,
        "intervention-request": 0,
        custom: 0,
        stateful: 0,
        ...counts,
    };

    const notifications = triggeredEvents + interventions + custom + stateful;

    const variant = getVariant(counts);

    if (notifications === 0) {
        return null;
    }

    return (
        <Badge
            variant={variant}
            onClick={e => {
                e.stopPropagation();
                onClick();
            }}
            className={cn(" font-normal rounded-full")}
        >
            {formatNumber(notifications)}
        </Badge>
    );
};
